<template>
    <section class="audio-section" ref="audioSection">
        <div class="player-container" id="player_controls">

            <div class="row controls">
                <div class="col-sm-2 controls">

                    <div class="audio-section__btn-container" v-show="state.player_current_track != null && !state.playlist[state.player_current_track][0]">
                        <div v-show="showPrevButton" class="audio-section__play__btn--previous disable">
                            <svg class="audio-section__play__btn__icon" aria-hidden="true"><use xlink:href="#icon-play-prev" /></svg>
                        </div>
                        <div class="audio-section__play__btn--start disable">
                            <svg class="audio-section__play__btn__icon" aria-hidden="true"><use xlink:href="#icon-play" /></svg>
                        </div>
                        <div v-show="showNextButton" class="audio-section__play__btn--next disable">
                            <svg class="audio-section__play__btn__icon" aria-hidden="true"><use xlink:href="#icon-play-next" /></svg>
                        </div>
                    </div>


                    <div class="audio-section__btn-container" v-show="state.player_current_track != null && state.playlist[state.player_current_track][0]">
                        <div v-show="showPrevButton" class="audio-section__play__btn--previous" :class="{ disable: !isLoop && state.player_current_track === 0 }" @click="playPrev">
                            <svg class="audio-section__play__btn__icon" aria-hidden="true"><use xlink:href="#icon-play-prev" /></svg>
                        </div>
                        <div v-if="!state.is_playing  && showPlayButton" @click="$refs.audio.play()" class="audio-section__play__btn--start">
                            <svg class="audio-section__play__btn__icon" aria-hidden="true"><use xlink:href="#icon-play" /></svg>
                        </div>
                        <div v-else-if="showPlayButton" @click="$refs.audio.pause()" class="audio-section__play__btn--pause">
                            <svg class="audio-section__play__btn__icon" aria-hidden="true"><use xlink:href="#icon-play-pause" /></svg>
                        </div>
                        <div v-show="showNextButton" class="audio-section__play__btn--next" :class="{ disable: !isLoop && state.player_current_track === state.playlist.length - 1 }" @click="playNext">
                            <svg class="audio-section__play__btn__icon" aria-hidden="true"><use xlink:href="#icon-play-next" /></svg>
                        </div>
                    </div>

                </div>
                <div class="col-sm-8 title" v-if="state.player_current_track != null && state.playlist[state.player_current_track][0]">{{ state.playlist[state.player_current_track][1] }}</div>
                <div class="col-sm-2 time" v-if="state.player_current_track != null && state.playlist[state.player_current_track][0]">{{ currentTimeAfterFormat }} / {{ formatTime(duration) }}</div>

            </div>

            <audio ref="audio" class="audio-section__player" v-if="state.player_current_track != null" :src="state.playlist[state.player_current_track][0]"
                @ended="onEnded"
                @timeupdate="onTimeUpdate"
                @loadedmetadata="onLoadedmetadata"
                @play="play"
                @pause="pause"
            >
            </audio>

             <div class="sc-container">
                <div class="tdj2-sc" v-if="state.player_current_track != null && state.playlist[state.player_current_track][0]">
                    <div class="soundcloud_progress" ref="sc_container" @click="initSCProgress">
                        <div class="overlay" ref="sc_overlay" :style="'background-image: url(\'' + state.playlist[state.player_current_track][2]['indigo-inverted'] + '\');'" ></div>
                        <div class="stripes" ref="sc_stripes"></div>
                        <div class="background" ref="sc_background"></div>
                        <div class="preload" ref="sc_preload"></div>
                        <div class="progress" ref="sc_progress"></div>
                    </div>
                </div>
            </div>

        </div>

    </section>
</template>
<script>

/* eslint-disable */!(function(a){var e,l='<svg><symbol id="icon-play" viewBox="0 0 1024 1024"><path d="M511.2269 64.4608c-246.1655 0-446.4425 200.278-446.4425 446.4425 0 246.1655 200.277 446.4435 446.4425 446.4435s446.4425-200.278 446.4425-446.4435C957.6694 264.7388 757.3914 64.4608 511.2269 64.4608zM511.2269 901.5409c-215.4015 0-390.6376-175.2361-390.6376-390.6376 0-215.4015 175.2361-390.6365 390.6376-390.6365 215.4015 0 390.6365 175.2351 390.6365 390.6365C901.8634 726.3048 726.6273 901.5409 511.2269 901.5409zM705.3455 459.649l-238.807-129.622c-11.3347-6.186-23.5151-9.4556-35.2328-9.4556-34.5508 0-59.5927 26.5134-59.5927 63.0272v254.61248c0 36.5117 25.0419 62.9975 59.5927 63.0262 11.7166 0 23.8971-3.2696 35.1519-9.3993l240.087-129.7326c21.718-11.8262 34.1985-30.2735 34.1985-50.5743C740.7432 490.8216 727.852 471.9114 705.3455 459.649zM679.9227 513.0568 439.8356 642.7884c-4.1974 2.3183-7.168 2.6429-8.5299 2.6429-1.5247 0-3.7878 0-3.7878-7.2212V383.59859199999994c0-7.2212 2.263-7.2212 3.7878-7.2212 1.3629 0 4.3325 0.3543 8.5555 2.6429l238.8357 129.6507c1.7172 0.9533 3.0515 1.8524 4.0878 2.6429C682.0219 511.8587 681.0665 512.4577 679.9227 513.0568z"  ></path></symbol><symbol id="icon-play-pause" viewBox="0 0 1024 1024"><path d="M960 512c0-247.36-200.576-448-448-448C264.64 64 64 264.64 64 512c0 247.424 200.64 448 448 448C759.424 960 960 759.424 960 512zM128 511.936c0-212.032 171.904-384 384-384s384 171.968 384 384-171.904 384-384 384S128 723.968 128 511.936zM406.784 678.208c-22.656 0.064-41.088-19.072-41.088-42.56L365.696 383.04c0-23.68 18.432-42.688 41.152-42.688C429.568 340.224 448 359.488 448 382.976l0 252.544C448 659.136 429.568 678.272 406.784 678.208zM617.088 678.208C594.368 678.272 576 659.136 576 635.648L576 383.04c0-23.68 18.432-42.688 41.152-42.688 22.656-0.128 41.152 19.136 41.152 42.624l0 252.544C658.24 659.136 639.808 678.272 617.088 678.208z"  ></path></symbol><symbol id="icon-play-prev" viewBox="0 0 1024 1024"><path d="M128 102.4V928c0 17.673 14.327 32 32 32 17.673 0 32-14.327 32-32V102.4c0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32z m646.028 41.395l-404.352 331.09c-27.383 22.42-27.435 58.886 0 81.35l404.352 331.09c27.382 22.42 49.676 12.003 49.676-23.366V167.16c0-35.646-22.24-45.83-49.676-23.365z m-40.546-49.518c69.12-56.597 154.222-16.897 154.222 72.883v696.8c0 89.481-85.14 129.447-154.222 72.883L329.13 605.753c-58.7-48.064-58.662-132.353 0-180.386l404.352-331.09z" fill="" ></path></symbol><symbol id="icon-play-next" viewBox="0 0 1024 1024"><path d="M889.6 921.6V96c0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32v825.6c0 17.673 14.327 32 32 32 17.673 0 32-14.327 32-32z m-646.028-41.395l404.352-331.09c27.383-22.42 27.435-58.886 0-81.35l-404.352-331.09c-27.382-22.42-49.676-12.003-49.676 23.366V856.84c0 35.646 22.24 45.83 49.676 23.365z m40.546 49.518c-69.12 56.597-154.222 16.897-154.222-72.883v-696.8c0-89.481 85.14-129.447 154.222-72.883l404.352 331.09c58.7 48.064 58.662 132.353 0 180.386l-404.352 331.09z" fill="" ></path></symbol></svg>',t=(e=document.getElementsByTagName("script"))[e.length-1].getAttribute("data-injectcss");if(t&&!a.__iconfont__svg__cssinject__){a.__iconfont__svg__cssinject__=!0;try{document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>")}catch(e){console&&console.log(e)}}!function(e){if(document.addEventListener)if(~["complete","loaded","interactive"].indexOf(document.readyState))setTimeout(e,0);else{var t=function(){document.removeEventListener("DOMContentLoaded",t,!1),e()};document.addEventListener("DOMContentLoaded",t,!1)}else document.attachEvent&&(n=e,c=a.document,o=!1,i=function(){o||(o=!0,n())},(l=function(){try{c.documentElement.doScroll("left")}catch(e){return void setTimeout(l,50)}i()})(),c.onreadystatechange=function(){"complete"==c.readyState&&(c.onreadystatechange=null,i())});var n,c,o,i,l}(function(){var e,t,n,c,o,i;(e=document.createElement("div")).innerHTML=l,l=null,(t=e.getElementsByTagName("svg")[0])&&(t.setAttribute("aria-hidden","true"),t.style.position="absolute",t.style.width=0,t.style.height=0,t.style.overflow="hidden",n=t,(c=document.body).firstChild?(o=n,(i=c.firstChild).parentNode.insertBefore(o,i)):c.appendChild(n))})}(window));

import { tdj2 } from '@/tdj2.js'

export default {

    name: 'Player',

    props: {
        showPlayButton: {
            default: true,
            type: Boolean
        },
        showPrevButton: {
            default: true,
            type: Boolean
        },
        showNextButton: {
            default: true,
            type: Boolean
        },
        showProgressBar: {
            default: true,
            type: Boolean
        },
        beforePlay: {
            default: null,
            type: Function
        },
        beforePrev: {
            default: null,
            type: Function
        },
        beforeNext: {
            default: null,
            type: Function
        },
        isLoop: {
            default: true,
            type: Boolean
        },
        progressInterval: {
            default: 100,
            type: Number
        }
    },

    data() {
        return {
            state: tdj2.state,
            isIOS: /iPhone|iPad|iPod/i.test(window.navigator.userAgent),
            timer: null,
            duration: '',
            currentTime: '',
            currentTimeAfterFormat: '',
            isDragging: false,
            currentInstance: null
        }
    },

    methods: {

        goto(progress) {
            console.log('goto ' + progress)
            console.log(Math.round(progress * this.$refs.audio.duration))
            this.$refs.audio.currentTime = Math.round(progress * this.$refs.audio.duration)
        },

        onScroll() {
            if (!document.getElementById('player_controls')){
                return;
            }
            let limit = 100 - 16;
            //console.log([window.innerHeight, document.body.scrollHeight, window.scrollY])
            let offset = document.body.scrollHeight - window.innerHeight - window.scrollY;
            if (offset > limit) {
                document.getElementById('player_controls').classList.add('detached')
            } else {
                document.getElementById('player_controls').classList.remove('detached')
            }
        },

        onResize: function () {
            if (!this.$refs.sc_container) {
                return;
            }
            //console.log('onresize');
            let width = this.$refs.sc_container.offsetWidth - 10;
            this.$refs.sc_overlay.style.backgroundSize = width + 'px 70px';
            this.$refs.sc_overlay.style.width = width + 'px';
            this.$refs.sc_stripes.style.width = width + 'px';
            this.$refs.sc_background.style.width = width + 'px';
            this.onScroll()
        },

    onLoadedmetadata(event) {
      this.duration = this.$refs.audio.duration
      //this.initProgressBarDrag()
      this.$emit('loadedmetadata', event)
    },

    onTimeUpdate(event) {
      this.$emit('timeupdate', event)
    },

    formatTime(second) {
      return [parseInt((second / 60) % 60), parseInt(second % 60)].join(':').replace(/\b(\d)\b/g, '0$1')
    },

    onEnded(event) {
      this.pause()
      this.currentTimeAfterFormat = this.formatTime(this.$refs.audio.currentTime)
      this.$emit('ended', event);
      this.playNext();
    },

    // initProgressBarDrag() {
    //   this.$refs.audioProgressPoint.addEventListener(
    //     'touchstart',
    //     event => {
    //       this.isDragging = true
    //     },
    //     false
    //   )
    //   this.$refs.audioProgressPoint.addEventListener(
    //     'touchmove',
    //     event => {
    //       let touch = event.touches[0]
    //
    //       if (touch.pageX < this.$refs.audioProgressContainer.getBoundingClientRect().left) {
    //         //console.log('var1')
    //         this.$refs.audioProgressPoint.style.left = 0
    //         this.$refs.audioProgress.style.width = 0
    //         this.currentTime = 0
    //         this.currentTimeAfterFormat = this.formatTime(this.currentTime)
    //         return
    //       }
    //
    //       if (touch.pageX > this.$refs.audioProgressContainer.getBoundingClientRect().right ) {
    //         //console.log('var2')
    //         // this.$refs.audioProgressPoint.style.left =
    //         //   this.$refs.audioProgressContainer.offsetWidth -
    //         //   this.$refs.audioProgressPoint.offsetWidth + 'px'
    //         this.$refs.audioProgress.style.width = this.$refs.audioProgressContainer.offsetWidth + 'px'
    //         this.currentTime = this.duration - 0.1
    //         this.currentTimeAfterFormat = this.formatTime(this.currentTime)
    //         return
    //       }
    //       //console.log('var3')
    //       this.setPointPosition(touch.pageX)
    //       this.$refs.audioProgress.style.width = touch.pageX - this.$refs.audioProgressContainer.getBoundingClientRect().left + 'px'
    //       this.currentTime =
    //         this.$refs.audioProgress.offsetWidth / this.$refs.audioProgressContainer.offsetWidth * this.duration
    //       this.currentTimeAfterFormat = this.formatTime(this.currentTime)
    //     },
    //     false
    //   )
    //   this.$refs.audioProgressPoint.addEventListener(
    //     'touchend',
    //     event => {
    //       // 设置播放位置
    //       this.$refs.audio.currentTime = this.currentTime
    //       // 设置未拖拽
    //       this.isDragging = false
    //     },
    //     false
    //   )
    // },

    // setPointPosition(pageX) {
    //   // this.$refs.audioProgressPoint.style.left =
    //   //   pageX - this.$refs.audioProgressPoint.offsetWidth / 2 - this.$refs.audioProgressContainer.getBoundingClientRect().left + 'px'
    // },

    // initProgressBarPoint(event) {
    //
    //   this.currentTime = (event.pageX - this.$refs.audioProgressContainer.getBoundingClientRect().left) /
    //           (this.$refs.audioProgressContainer.getBoundingClientRect().width) * this.duration
    //
    //     //console.log('trying to set ' + this.currentTime)
    //   this.$refs.audio.currentTime = this.currentTime
    //
    //   // this.setPointPosition(event.pageX)
    //   // 设置进度条
    //   this.$refs.audioProgress.style.width = event.pageX - this.$refs.audioProgressContainer.getBoundingClientRect().left + 'px'
    //   // 设置当前时间（格式化后）
    //   this.currentTimeAfterFormat = this.formatTime(this.currentTime)
    // },

    initSCProgress(event) {

      this.currentTime = (event.pageX - this.$refs.sc_container.getBoundingClientRect().left) /
              (this.$refs.sc_container.getBoundingClientRect().width) * this.duration

        //console.log('trying to set ' + this.currentTime)
      this.$refs.audio.currentTime = this.currentTime
      // this.setPointPosition(event.pageX)
      // this.$refs.audioProgress.style.width = event.pageX - this.$refs.audioProgressContainer.getBoundingClientRect().left + 'px'
      this.currentTimeAfterFormat = this.formatTime(this.currentTime)
    },

    playing() {

        // let slider_width = this.$refs.audioProgressContainer.offsetWidth;
        let sc_width = this.$refs.sc_container.offsetWidth - 10;

        if (this.$refs.audio.buffered.length) {
            // this.$refs.audioLoadingProgress.style.width = this.$refs.audio.buffered.end(0) / this.$refs.audio.duration * slider_width + 'px';
            this.$refs.sc_preload.style.width = -10 + Math.round(this.$refs.audio.buffered.end(0) / this.$refs.audio.duration * sc_width) + 'px';
        }

        if (this.isDragging) {
            return
        }

        this.currentTimeAfterFormat = this.formatTime(this.$refs.audio.currentTime);
        this.$refs.sc_progress.style.width = Math.round(this.$refs.audio.currentTime / this.$refs.audio.duration * sc_width) + 'px';
        // this.$refs.audioProgress.style.width = Math.round(this.$refs.audio.currentTime / this.$refs.audio.duration * slider_width) + 'px'
        this.$root.$emit('player-playing', this.$refs.audio.currentTime / this.$refs.audio.duration)

    },

        reset_progress() {
            this.$refs.sc_progress.style.width = '0px';
        },

                try_reset() {
            if (this.currentInstance != this.state.playlist[this.state.player_current_track][3]) {
                this.reset_progress();
                this.currentInstance = this.state.playlist[this.state.player_current_track][3];
            }
        },

    play() {


        let playHandle = () => {
        // this.$refs.audio.play()
          this.try_reset();
        this.$nextTick(() => {
            this.try_reset();
            this.onResize();
            this.playing();
            this.timer = setInterval(this.playing, this.progressInterval)
            this.state.is_playing = true
            this.$root.$emit('play-instance', this.state.playlist[this.state.player_current_track][3])
        })
      }

      // if (this.isIOS) {
      //   this.$refs.audio.play()
      //   this.$refs.audio.pause()
      // }
      if (this.beforePlay) {
        this.beforePlay((state) => {
          if (state !== false) {
            playHandle()
          }
        })
        return
      }
      playHandle()
    },

    pause() {
      // this.$refs.audio.pause()
      this.$nextTick(() => {
        clearInterval(this.timer)
        this.state.is_playing = false
        this.$root.$emit('pause-instance', this.state.playlist[this.state.player_current_track][3])
      })
    },

        remote_play() {
            this.$refs.audio.play()
        },

        remote_pause() {
            this.$refs.audio.pause()
        },

    playPrev() {
      if (this.state.player_current_track <= 0 && !this.isLoop) {
        return
      }
      let prevHandle = () => {
          this.$root.$emit('pause-instance', this.state.playlist[this.state.player_current_track][3])
        if (this.state.player_current_track <= 0 && this.isLoop) {
          this.state.player_current_track = this.state.playlist.length - 1
        } else {
          this.state.player_current_track--
        }
        this.$nextTick(() => {
          this.$refs.audio.play()
          // this.isPlaying = true
          this.$emit('play-prev')
        })
      }
      if (this.beforePrev) {
        this.beforePrev((state) => {
          if (state !== false) {
            prevHandle()
          }
        })
        return
      }
      prevHandle()
    },

    playNext() {
      if (this.state.player_current_track + 1 >= this.state.playlist.length && !this.isLoop) {
        return
      }
      let nextHandle = () => {
          this.$root.$emit('pause-instance', this.state.playlist[this.state.player_current_track][3])
        if (this.state.player_current_track + 1 >= this.state.playlist.length && this.isLoop) {
          this.state.player_current_track = 0
        } else {
            this.state.player_current_track++
            while((this.state.player_current_track + 1 < this.state.playlist.length) && (this.state.playlist[this.state.player_current_track][4] == this.state.playlist[this.state.player_current_track-1][4])) {
                this.state.player_current_track++
            }
        }
        this.$nextTick(() => {
          this.$refs.audio.play()
          // this.isPlaying = true
          this.$emit('play-next')
        })
      }
      if (this.beforeNext) {
        this.beforeNext((state) => {
          if (state !== false) {
            nextHandle()
          }
        })
        return
      }
      nextHandle()
    }
  },
  beforeDestroy() {
    this.pause()
  },

    watch:{
        $route (to, from){
            this.onScroll()
        }
    },

    created() {
        //console.log('created')
        //console.log(this.$root)
        this.$nextTick(function() {
            window.addEventListener('resize', this.onResize);
            window.addEventListener('scroll', this.onScroll);
        });

        this.$root.$on('player-goto', this.goto);
        this.$root.$on('player-play', this.remote_play);
        this.$root.$on('player-pause', this.remote_pause);
        this.$root.$on('PlayFile', () => {
            //console.log('catch play signal')
            this.$nextTick(() => {
                //console.log(this.state.playlist)
                //console.log(this.state.player_current_track)
                this.$refs.audio.play()
            })
        });

            this.$root.$on('lpUpdateHeight', () => {
                this.onScroll()
            });

    }

}
</script>
<style lang="less">

    #player_controls.detached {
        position: fixed;
        bottom:-24px;
        width: 100%;
    }

    #player_controls {
        border-top: 1px solid #CCCCCC;
        background-color: #5c6bc0;
        width: 100%;
        height: 116px;
    }

    .row.controls {
        height: 41px;
        /*background-color: green;*/

        div.controls {
            padding-top: 0px;
        }

        div.title, div.time {
            padding-top: 8px;
        }
    }

    .audio-section__btn-container {
        display: flex;
        margin-top: 6px;
        align-items: center;
        justify-content: center;
        .audio-section__play__btn__icon {
          width: 100%;
          height: 100%;
          fill: currentColor;
          overflow: hidden;
          color: #ffffff;
        }
        .audio-section__play__btn--previous {
          width: 17px;
          height: 26px;
          &.disable {
            opacity: 0.5;
          }
        }
        .audio-section__play__btn--start {
          width: 32px;
          height: 32px;
          margin: 0 20px;
            &.disable {
            opacity: 0.5;
          }
        }
        .audio-section__play__btn--pause {
          width: 32px;
          height: 32px;
          margin: 0 20px;
        }
        .audio-section__play__btn--next {
          width: 17px;
          height: 26px;
          &.disable {
            opacity: 0.5;
          }
        }
    }


    .soundcloud_progress{
        width: 100%;
        height: 70px;
        margin-left: 5px;
        margin-right: 5px;
        position: absolute;
        .background, .preload, .progress, .stripes, .overlay {
            position: absolute;
            top: 0px;
            height: 70px;
            border-radius: 0px;
        }
        .progress {
            background-color: white;
        }
        .preload {
            background-color: #8b96d2;
        }
        .background {
            background-color: #717ec8;
            width: 100%;
        }
        .overlay {
            z-index: 255;
            width: 100%;
        }
        .stripes {
            z-index: 255;
            width: 100%;
            background-image: url('/stripe-bg-indigo-25.png');
            background-repeat: repeat;
        }
    }

    .sc-container {
        height: 70px;
        background-color: #5c6bc0;
    }


</style>